import { Reducer } from 'redux'
import { SWAP_ACTIONS } from './const'
import { ActionTypes, FXQuote, FX_ACTION_STATUS, SwapPrefill, SwapTransactionLimit } from './types'

export type SwapState = {
  fxRate: number | undefined
  fxRateStatus: FX_ACTION_STATUS
  fxQuote: FXQuote | undefined
  fxQuoteStatus: FX_ACTION_STATUS
  transactionLimits: SwapTransactionLimit[] | undefined
  shouldHighlightSwapForm: boolean
  swapPrefill: SwapPrefill | null
}

const initialState: SwapState = {
  fxRate: undefined,
  fxRateStatus: FX_ACTION_STATUS.NOT_FETCHED,
  fxQuote: undefined,
  fxQuoteStatus: FX_ACTION_STATUS.NOT_FETCHED,
  transactionLimits: undefined,
  shouldHighlightSwapForm: false,
  swapPrefill: null,
}

export const swap: Reducer<SwapState, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case SWAP_ACTIONS.SET_SWAP_FX_RATE: {
      return {
        ...state,
        fxRate: action.data,
      }
    }

    case SWAP_ACTIONS.SET_SWAP_FX_RATE_STATUS: {
      return {
        ...state,
        fxRateStatus: action.status,
      }
    }

    case SWAP_ACTIONS.SET_SWAP_FX_QUOTE: {
      return {
        ...state,
        fxQuote: action.data,
      }
    }

    case SWAP_ACTIONS.SET_SWAP_FX_QUOTE_STATUS: {
      return {
        ...state,
        fxQuoteStatus: action.status,
      }
    }

    case SWAP_ACTIONS.SET_SWAP_TRANSACTION_LIMITS: {
      return {
        ...state,
        transactionLimits: action.transactionLimits,
      }
    }

    case SWAP_ACTIONS.SET_SHOULD_HIGHLIGHT_SWAP_FORM: {
      return {
        ...state,
        shouldHighlightSwapForm: action.shouldHighlightSwapForm,
      }
    }

    case SWAP_ACTIONS.SET_SWAP_FORM_PREFILL: {
      return {
        ...state,
        swapPrefill: action.swapPrefill,
      }
    }

    default:
      return state
  }
}
